import React, { useMemo } from 'react';
import { Container, Content, FileSelected } from './styled';
import { BiLinkExternal } from 'react-icons/bi';
import { IoMdTrash } from 'react-icons/io';
import { PreviewFile } from '../../components';

export function AttachFiles(props) {
    const { files, setFiles } = props;

    const removeFile = (file) => {
        setFiles((prevFiles) => prevFiles.filter((f) => f !== file));
    };

    const myStateElements = useMemo(() => {
        return files?.map((file) => {
            const fileUrl = URL.createObjectURL(file);
            return (
                <FileSelected key={`${file?.name}-${file?.lastModified}`}>
                    <div className='action--file'>
                        <BiLinkExternal
                            className={`link-- ${!file?.type && 'disabled--'}`}
                            onClick={() => window.open(fileUrl, '_blank')}
                        />
                        <IoMdTrash
                            className='trash--'
                            onClick={() => removeFile(file)}
                        />
                    </div>
                    <PreviewFile
                        name={file?.name}
                        url={fileUrl}
                        type={file?.type}
                    />
                </FileSelected>
            );
        }).filter(Boolean); // Filtrar elementos nulos ou indefinidos (caso o array files seja nulo ou indefinido)
    }, [files]);

    return (
        <Container>
            <Content>
                {files && myStateElements}
            </Content>
        </Container>
    );
}